
type Options = {
	decimals?: number;
	notation?: "standard" | "scientific" | "engineering" | "compact";
};


const _toCurrency = (value: number, options: Options) => {
	const { decimals = 0, notation = "standard" } = options;

	return new Intl.NumberFormat("en-us", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		useGrouping: true,
		notation
	}).format(value);
};


const _toDecimal = (value: number, options: Options = {}) => {
	const { decimals = 0, notation = "standard" } = options;

	return new Intl.NumberFormat("en-us", {
		style: "decimal",
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		useGrouping: true,
		notation
	}).format(value);
};

const _toPercentage = (value: number, options: Options = {}) => {
	const { decimals = 0, notation = "standard" } = options;

	return new Intl.NumberFormat("en-us", {
		style: "percent",
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		useGrouping: true,
		notation
	}).format(value);
};

const format = (value: number | undefined | null, type: "currency" | "number" | "percentage", options: Options = {}) => {
	if (value === undefined || value === null || isNaN(value)) return "";
	switch (type) {
		case "currency":
			return _toCurrency(value, options);
		case "number":
			return _toDecimal(value, options);
		case "percentage":
			return _toPercentage(value, options);
		default:
			throw new Error(`Unsupported format type: ${type}`);
	}
};

const pad = (v: number, size = 2) => v.toString().padStart(size, "0");


const toPhone = (v?: string) => {
	if (!v) return "";
	const digits = v.replace(/\D/g, "").slice(0, 10);
	const lenght = digits.length;
	if (lenght === 0) return "";
	if (lenght < 4) return `(${digits}`;
	if (lenght < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export default {
	format,
	pad,
	toPhone
};